export default __webpack_public_path__ + "static/media/technical-recruitment-is.c4bb4b47.png";